import { DateTime } from "luxon";
import { useState } from "react";

import {
  IgButton,
  IgCodeEditor,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { Box, Grid, useTheme } from "@mui/material";

import { usePatchConfigurations } from "../../api/configurations/patch-configurations";
import { useConfiguration } from "../../api/configurations/use-configuration";

interface GlobalCssAndJsSettingProps {
  type: "css" | "javascript";
}

export const GlobalCssAndJsSettings = ({
  type,
}: GlobalCssAndJsSettingProps) => {
  const theme = useTheme();
  const mutateConfigurations = usePatchConfigurations();
  const settings = useConfiguration(type);
  const [data, setData] = useState<string>(settings?.value || "");
  const formattedLastUpdateTimeStamp = settings
    ? DateTime.fromMillis(settings.lastUpdateTs).toLocaleString(
        DateTime.DATETIME_FULL
      )
    : null;

  const onClick = () => {
    mutateConfigurations.mutate([
      {
        ...settings,
        value: data,
      },
    ]);
  };

  return (
    <Grid item>
      <IgPaper>
        <Grid container direction={"column"} rowSpacing={3}>
          <Grid item>
            <IgTypography variant="h3" fontWeight={"fontWeightMedium"}>
              {type === "css" ? "Global CSS Styles" : "Global JavaScript"}
            </IgTypography>
          </Grid>
          <Grid item>
            <IgTypography color={theme.palette.text.secondary}>
              {type === "css"
                ? `Inject custom CSS styles on your site. These styles will always be
              applied while Intelligems is installed.`
                : `Inject custom JavaScript into your site. These scripts will always be
              applied while Intelligems is installed`}
            </IgTypography>
          </Grid>
          <Grid
            container
            item
            direction={"row"}
            sx={{
              alignItems: "center",
              flexWrap: "nowrap",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Grid container item direction={"column"} rowSpacing={1}>
              <Box
                sx={{
                  border: "solid 1px #CBCBCB",
                  marginRight: "10px",
                  width: "100%",
                }}
              >
                <IgCodeEditor
                  language={type === "css" ? "css" : "js"}
                  height="300px"
                  value={data}
                  onChange={(e) => {
                    setData(e || "");
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item mt={2}>
            <IgButton
              loading={mutateConfigurations.isPending}
              onClick={onClick}
              variant={"contained"}
            >
              Save
            </IgButton>
            {formattedLastUpdateTimeStamp ? (
              <IgTypography
                ml={4}
                variant={"body2"}
                color={theme.palette.text.secondary}
              >
                Last updated {formattedLastUpdateTimeStamp}
              </IgTypography>
            ) : null}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
